import axios from 'axios'
import { useAuth } from 'contexts/AuthProvider';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_CMS_API_URL + '/api',
  // other configurations
})

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { login } = useAuth();
    if (error.response && error.response.status === 401) {
      console.log('call the refresh token api here')
      // Handle 401 error, e.g., redirect to login or refresh token
    }
    return Promise.reject(error)
  },
)

export default axiosInstance